export default function initAddToFavorite() {
    setTimeout(() => {
        checkForFavoriteEvents();
    }, 2200);

    checkForFavoriteEvents();

    const addToFavoriteBtns = document.querySelectorAll('[data-add-to-favorite]');
    const favoriteEvents = localStorage.getItem('gestev-favorite-events')
        ? JSON.parse(localStorage.getItem('gestev-favorite-events'))
        : [];

    addToFavoriteBtns.forEach((btn) => {
        const eventId = btn.getAttribute('data-add-to-favorite');

        btn.addEventListener('click', (e) => {
            e.preventDefault();

            const card = btn.closest('.events-item')
                ? btn.closest('.events-item')
                : btn.closest('.events-details-content');
            const cardCategories = card.querySelectorAll('.img .categories span');

            if (favoriteEvents.includes(eventId)) {
                // Remove from favorite
                const index = favoriteEvents.indexOf(eventId);

                if (index > -1) {
                    favoriteEvents.splice(index, 1);
                }

                btn.classList.remove('is-active');

                // Traking
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'remove_wl',
                    clic_location: document.querySelector('body').getAttribute('data-section'),
                    event_name: card.querySelector('h2').innerText,
                    event_date: card.querySelector('time')
                        ? card.querySelector('time').innerText
                        : card.querySelector('.time').innerText,
                    event_place: card.querySelector('.salle').innerText,
                    event_type: cardCategories[0] ? cardCategories[0].innerText : '',
                    event_type2: cardCategories[1] ? cardCategories[1].innerText : '',
                    event_type3: cardCategories[2] ? cardCategories[2].innerText : '',
                    event_type4: cardCategories[3] ? cardCategories[3].innerText : '',
                });
                console.log('remove_wl');
            } else {
                // Add to favorite
                favoriteEvents.push(eventId);
                btn.classList.add('is-active');

                // Tracking
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'add_wl',
                    clic_location: document.querySelector('body').getAttribute('data-section'),
                    event_name: card.querySelector('h2').innerText,
                    event_date: card.querySelector('time')
                        ? card.querySelector('time').innerText
                        : card.querySelector('.time').innerText,
                    event_place: card.querySelector('.salle').innerText,
                    event_type: cardCategories[0] ? cardCategories[0].innerText : '',
                    event_type2: cardCategories[1] ? cardCategories[1].innerText : '',
                    event_type3: cardCategories[2] ? cardCategories[2].innerText : '',
                    event_type4: cardCategories[3] ? cardCategories[3].innerText : '',
                });
                console.log('add_wl');
            }

            localStorage.setItem('gestev-favorite-events', JSON.stringify(favoriteEvents));
        });
    });
}

function checkForFavoriteEvents() {
    // Add to favorite btns [data-add-to-favorite] attribute ex: <button data-add-to-favorite="1"></button> where 1 is the event id
    // Using localStorage to save favorite events
    const addToFavoriteBtns = document.querySelectorAll('[data-add-to-favorite]');
    const favoriteEvents = localStorage.getItem('gestev-favorite-events')
        ? JSON.parse(localStorage.getItem('gestev-favorite-events'))
        : [];

    addToFavoriteBtns.forEach((btn) => {
        const eventId = btn.getAttribute('data-add-to-favorite');

        const favBtns = document.querySelectorAll('.add-to-favorites');

        if (favoriteEvents.length) {
            favBtns.forEach((favBtn) => {
                favBtn.classList.add('is-active');
            });
        } else {
            favBtns.forEach((favBtn) => {
                favBtn.classList.remove('is-active');
            });
        }

        if (favoriteEvents.includes(eventId)) {
            btn.classList.add('is-active');
        } else {
            btn.classList.remove('is-active');
        }
    });
}
